import ExcelJS, { Column } from 'exceljs';
import { SheetFactory } from './SheetFactory';


export const downloadRelatorioExcel = async (
  dadosRows: Array<any>,
  colunaSize: Array<number>,
  tituloRelatorio: string,
  tituloColuna: Array<string>) => {

  // var users = [{
  //   "id": 1,
  //   "name": "John",
  //   "purchases_value": 1000
  // }]

  const sheet = new SheetFactory();
  //sheet.setColumnSizes([30, 30, 50]);
  sheet.setColumnSizes(colunaSize);

  //sheet.addTitleRow(["Relatório"]);
  sheet.addTitleRow([tituloRelatorio]);

  //sheet.addSubtitleRow(["ID", "Nome", "valor das compras"]);
  sheet.addSubtitleRow(tituloColuna);

  // const userRows = users.map(({ id, name, purchases_value }) => [
  //   id,
  //   name,
  //   purchases_value,
  // ]);

  //sheet.addRows(userRows);

  sheet.addRows(dadosRows);

  const buffer = await sheet.finishSheet();
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  var blob = new Blob([buffer], { type: fileType });

  let url = window.URL.createObjectURL(blob);
  let a = document.createElement("a");
  a.href = url;
  //a.download = "relatório-final.xlsx";
  a.download = `${tituloRelatorio}.xlsx`;
  a.click();
}